// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"298":"0d0f1613","535":"ed4edc3c","719":"1fd84cd6","727":"990d1427","766":"aa5137e1","913":"d9efb0ca","920":"a8aac217"}[chunkId] + ".chunk.css";
};